import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-apollo';
import { List, ListItem, ListItemSecondaryAction, ListItemText, ListSubheader, Typography, IconButton } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';

import { Layout } from '../../components/Layout';
import { FeedbackBar } from '../../components/FeedbackBar';
import { UserVesselsContext, UserVesselsProvider } from '../../contexts/userVessels';
import { resolveVesselName } from '../../util/lang';
import { DELETE_USER_VESSEL } from './mutations';

const useStyles = makeStyles((theme) => ({
  listContainer: {
    maxWidth: 300
  }
}));

const UserVesselsList = () => {
  const { userVessels, fetchUserVessels } = useContext(UserVesselsContext);
  const { t } = useTranslation();
  const classes = useStyles();

  const [doDeleteUserVessel, { loading, error, data }] = useMutation(DELETE_USER_VESSEL);

  const deleteUserVessel = (id) => {
    doDeleteUserVessel({
      variables: {
        id
      }
    });
  };

  useEffect(
    () => {
      if (!loading && !error && data?.userVesselRemoveById) {
        fetchUserVessels();
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, loading, error]
  );

  return (
    <>
      <List className={classes.listContainer}>
        <ListSubheader>
          <Typography variant="h5">{t('UserVessels.DeleteVessels')}</Typography>
        </ListSubheader>
        {userVessels?.map((s, i) => (
          <ListItem key={i}>
            <ListItemText primary={resolveVesselName(s.name, userVessels)} />
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="delete" onClick={() => deleteUserVessel(s._id)}>
                <Delete />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <FeedbackBar message={error} />
    </>
  );
};

export const UserVessels = () => {
  const { t } = useTranslation();

  return (
    <UserVesselsProvider>
      <Layout title={t('UserVessels.ManageYourVessels')}>
        <UserVesselsList />
      </Layout>
    </UserVesselsProvider>
  );
};
